import { useState, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { editCustDetailsFormValidationSchema } from "./editCustDetailsFormValidationSchema";
import { SideFlyout, ToastNotification } from "../../common/components";
import { EditCustomerDetailsForm } from "./EditCustomerDetailsForm";
import { useQuoteContext } from "../../context";
import { CUSTOMER_DETAILS_HEADING } from "../../common/constant";

const EditCustomerDetails = ({ showEditCustDetails, hideEditCustomerDetails }) => {
	const [toast, setToast] = useState(null);
	const { MainCust, Owner, InsideRep } = useQuoteContext();
	const isCustomerAdded = MainCust?.AccountName !== "";

	const getDefaultFormValues = () => ({
		customer: MainCust?.AccountName,
		email: MainCust?.EmailAddress,
		fullName:
			MainCust?.FirstName || MainCust?.LastName
				? `${MainCust?.FirstName} ${MainCust?.LastName}`
				: "",
		phone: MainCust?.DayPhone,
		primaryRep: Owner,
		insideRep: InsideRep
	});

	const methods = useForm({
		mode: "onBlur",
		defaultValues: getDefaultFormValues(),
		resolver: yupResolver(editCustDetailsFormValidationSchema)
	});

	useEffect(() => {
		methods.reset(getDefaultFormValues());
	}, [
		MainCust?.AccountName,
		MainCust?.EmailAddress,
		MainCust?.FirstName,
		MainCust?.LastName,
		MainCust?.DayPhone,
		Owner?.DisplayName,
		InsideRep?.DisplayName
	]);

	const isFormValid = () => Object.keys(methods.formState.errors).length === 0;

	const handleExplicitClose = () => {
		methods.reset(getDefaultFormValues());
		hideEditCustomerDetails(true);
	};

	const handleDismissAttempt = () => {
		if (!isCustomerAdded || isFormValid()) {
			hideEditCustomerDetails(true);
		}
	};

	return (
		<>
			<FormProvider {...methods}>
				<SideFlyout
					title={CUSTOMER_DETAILS_HEADING}
					open={showEditCustDetails}
					onClose={handleDismissAttempt}
					onCloseClick={handleExplicitClose}
				>
					<EditCustomerDetailsForm toast={toast} setToast={setToast} />
				</SideFlyout>
			</FormProvider>
			<ToastNotification toast={toast} setToast={setToast} />
		</>
	);
};

export { EditCustomerDetails };
